import React from 'react';
import styles from '../../styles/educationFair.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import router from 'next/router';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';
interface Props {
    eventData: any;
}

const FuturereadySection: React.FC<Props> = ({ eventData }) => {
     const { zipmeLink, generateLink } = useZipmeLink();
    return (
        <div className={styles.accomplishSection} style={{ background: `linear-gradient(0deg, ${eventData?.futureReadySection?.sectionBgColorBottom || '#EEF2FB'} 50%, ${eventData?.futureReadySection?.sectionBgColorTop || '#ffffff'} 0)` }}>
            <div className={styles.studentFooter}>
                <Container>
                    <Row>
                        <Col>
                            <div className={styles.session}>
                                <div>
                                    <h3 style={{ color: eventData?.titleTextColor || "#fff" }}>{eventData?.futureReadySection?.sectionTitle}</h3>
                                </div>
                                <div className={styles.anchor}>
                                    <a
                                        onClick={() => {
                                        !eventData?.meta?.jotforms[0]?.jotformid && 
                                            generateLink(eventData?.externalLink);
                                        }}
                                        className={`btn btn-primary   ${
                                        eventData?.meta?.jotforms[0]?.jotformid
                                            ? ` ${isFrappeOrJotFormClass(eventData?.meta?.jotforms[0]?.jotformid)}`
                                            : ''
                                        }`}
                                    >
                                      Register Now
                                    </a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default FuturereadySection;